import { createElement } from 'react';
import { resolveEventDecision } from './decisionRegistry.js';

/**
 * Dispatches to the per-type decision component (sticky footer + confirm modals),
 * falling back to the generic single-primary decision. `createElement` avoids the
 * react-compiler "component created during render" rule.
 */
function EventDecisionFooter({ event, actions }) {
  return createElement(resolveEventDecision(event.type), { event, actions });
}

export default EventDecisionFooter;
